import { type LucideProps } from 'lucide-react';
import React from 'react';
function LogoIcon(props: LucideProps) {
  return (
    <svg
      width="45"
      height="25"
      viewBox="0 0 41 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.14741 4.83013C3.50657 5.72101 3.12943 6.8137 3.12943 7.99447C3.12943 9.17525 3.50657 10.2679 4.14741 11.1588V20.7689H0.5V0.029541H4.14741V4.82985V4.83013Z"
        fill="currentColor"
      />
      <path d="M22.8178 0.0297852H19.1704V15.9421H22.8178V0.0297852Z" fill="currentColor" />
      <path d="M28.956 0.0297852H25.3086V15.9421H28.956V0.0297852Z" fill="currentColor" />
      <path
        d="M8.93589 0C4.52052 0 0.941406 3.57912 0.941406 7.99448C0.941406 12.4098 4.52052 15.989 8.93589 15.989C13.3512 15.989 16.9304 12.4098 16.9304 7.99448C16.9304 3.57912 13.3512 0 8.93589 0ZM8.55567 12.7215C5.94492 12.7215 3.82867 10.605 3.82867 7.99448C3.82867 5.38401 5.9452 3.26748 8.55567 3.26748C11.1661 3.26748 13.2827 5.38401 13.2827 7.99448C13.2827 10.605 11.1661 12.7215 8.55567 12.7215Z"
        fill="currentColor"
      />
      <path
        d="M8.71488 10.911C10.3256 10.911 11.6314 9.60518 11.6314 7.99442C11.6314 6.38366 10.3256 5.07788 8.71488 5.07788C7.10412 5.07788 5.79834 6.38366 5.79834 7.99442C5.79834 9.60518 7.10412 10.911 8.71488 10.911Z"
        fill="currentColor"
      />
      <path
        d="M27.2656 6.9221L35.0346 0.0297852H40.1137L27.4067 11.6385L27.2656 6.9221Z"
        fill="currentColor"
      />
      <path
        d="M32.2377 6.06348L29.731 8.76482L35.5412 15.942H40.4998L32.2377 6.06348Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default LogoIcon;
